import { useEffect } from 'react';
import { eventBus, EventBusEvent } from '../../api/apiEventBus';

export function useAuthErrorEvent(
  callback: (status: number | undefined) => void
) {
  useEffect(() => {
    const handler: EventListenerOrEventListenerObject = (ev: EventBusEvent) => {
      const status = ev.detail?.status;
      if ([401, 403, 498].includes(status as number)) {
        callback(status);
      }
    };

    eventBus.addEventListener('auth-error', handler);
    return () => eventBus.removeEventListener('auth-error', handler);
  }, [callback]);
}
